import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import styles from "./layout.module.css";
import { useSelector } from "react-redux";

function AppLayout() {
  const [sideNavExpanded, setSideNavExpanded] = useState(false);
  const role = useSelector((state) => state.auth.role.roleName);
    useEffect(() => {
      // Set background for authenticated pages
      document.body.style.background = "#F2ECE4";

      // Clean up when unmounting (e.g. on logout)
      return () => {
        document.body.style.background = ""; // or default color like "#fff"
      };
    }, []);
  return (
    <div>
      <div
        className={`${styles.content} ${
          sideNavExpanded ? `${styles[`${role}-expanded`]}` : ""
        }`}
      >
        <Outlet />
      </div>
      <Sidebar
        setSideNavExpanded={setSideNavExpanded}
        sideNavExpanded={sideNavExpanded}
      />
    </div>
  );
}

export default AppLayout;
